'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import 'slick-carousel';

// ----------------------------------------
// Private
// ----------------------------------------

let $mainSlider = $('.main-slider');
let $firmsSlider = $('.firms-slider');
let $reviewsSlider = $('.review-img-slider');

// ----------------------------------------
// Public
// ----------------------------------------

function mainSlider () {
	$mainSlider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		infinite: true,
		dots: true,
		fade: true,
		appendDots: $('.main-slider__controls'),
		prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-arrow slick-next"></button>'
	});
}

function firmsSlider () {
	$firmsSlider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		infinite: true,
		dots: true,
		fade: true,
		appendDots: $('.firms-slider__controls'),
		prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-arrow slick-next"></button>'
	});
}

function reviewsSlider () {
	$reviewsSlider.slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		vertical: true,
		prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					vertical: false
				}
			}, {
				breakpoint: 640,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {mainSlider, firmsSlider, reviewsSlider};



// WEBPACK FOOTER //
// ./src/js/_modules/sliders.js